<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup>
// App component - sử dụng script setup
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}
</style> 